import * as Models from 'models';
import { colorExistsInBrandColors } from 'utils/brandStyles';

/**
 * Returns available background color name
 */
export function matchBackgroundColor(
  backgroundColorName: string | undefined,
  colors: Models.BrandColorsList,
  brandBackgroundColorName: string | null = null,
): string | null {
  if (backgroundColorName && !colorExistsInBrandColors(backgroundColorName, colors)) {
    return brandBackgroundColorName;
  }

  return backgroundColorName ?? null;
}
